'use client';

import Lottie from 'lottie-react';
import snowflakeBlue from '@/assets/theme/default/lottie/snowflakeBlue.json';
import styles from './snowflakeAnimation.module.css';
import { Box } from '@mui/material';

export const SnowflakeAnimation = () => {
    return (
        <Box data-testid="snow-flakes-animation" className={styles.snowflakeContainer}>
            <Lottie
                animationData={snowflakeBlue}
                className={`${styles.snowflakeAnimation} HeaderLogoNewYearAnimation`}
            />
        </Box>
    );
};
